export default fn => e => fn(e.target.value);
